var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FETCH_PRICE_AUDIT_REPORT_REQUEST, FETCH_PRICE_AUDIT_REPORT_SUCCESS, FETCH_PRICE_AUDIT_REPORT_ERROR } from 'actionTypes';
var DEFAULT_STATE = {
    error: null,
    isFetching: false,
    list: [],
};
export default (function (state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case FETCH_PRICE_AUDIT_REPORT_REQUEST:
            return __assign(__assign({}, state), { error: null, isFetching: true });
        case FETCH_PRICE_AUDIT_REPORT_SUCCESS:
            return __assign(__assign({}, state), { error: null, isFetching: false, list: action.payload });
        case FETCH_PRICE_AUDIT_REPORT_ERROR:
            return __assign(__assign({}, state), { error: action.payload, isFetching: false });
        default:
            return state;
    }
});
